import React, {useEffect, useState, useRef, useCallback} from "react";
import logo from '../assets/images/logo.png';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faChevronLeft, faAngleRight, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import {faLinkedin, faSquareLinkedin, faSquareInstagram} from "@fortawesome/free-brands-svg-icons"
import { useLocation } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';
import SortableList from "./SortableList";
import Spinner from "react-activity/dist/Spinner";
import starimg from '../assets/images/main/stars-img.png';
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

const Header = () => {
  const { pathname } = useLocation();
  const [sticky, setSticky] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [previewloading, setpreviewloading] = useState(false);

  const savedlayouts = useSelector((store) => store.userReducer.savedlayouts);
  const dispatch = useDispatch();

  const [savedlayoutsarr, setsavedlayoutsarr] = useState([]);
  const savedlayoutsarrRef = useRef([]);
  savedlayoutsarrRef.current = savedlayoutsarr;

  const classes = `mainheader ${sticky} mobhide`;

  const toggleDrawer = (state) => {
    setOpen(state);
  };

  
    const toggleDrawer1 = (state) => {
        setOpen1(state);
    };

    const handlegenerateppt = async() => {
      if(savedlayoutsarrRef?.current?.length > 0) {
        setpreviewloading(true);
        var prevdata = savedlayoutsarrRef?.current;
        var prevarr = [];
        for(var i = 0; i < prevdata?.length; i++) {
          prevarr.push(prevdata[i]?.ppturl);
        }
        const headers = {
          headers: {
              'Content-Type': 'application/json'
          }
        }
        var data = {
          "ppt_paths": prevarr
        }
        let resp = await axios
              .post("https://www.theinkorporated.com/api/consolidate-slides", data, headers)
              .then((res) => {
                var prevdata = res?.data;
                window.open(prevdata?.output_path);
                setpreviewloading(false);
              }).catch((err) => {
                alert(err.message)
                setpreviewloading(false);
              })
              setpreviewloading(false);
      } else {

      }
      
    }

    const handlerespfunc = useCallback((t) => {
      console.log('handlerespfunc t >>', t);
    var newarr = t(savedlayoutsarrRef?.current);
    setsavedlayoutsarr(newarr);
    dispatch({ type: "savedlayouts", payload: newarr });
    }, []);

    const removeLayoutfunc = useCallback((t) => {
      var newarr = savedlayoutsarrRef?.current.filter((item) => item.id !== t);
      setsavedlayoutsarr(newarr);
      dispatch({ type: "savedlayouts", payload: newarr });
    }, [])
  
    useEffect(() => {
        setsavedlayoutsarr(savedlayouts);
        if(savedlayoutsarrRef?.current?.length > 0) {
          if(savedlayoutsarrRef?.current?.length == savedlayouts?.length) {

          } else {
            setOpen1(true)
          }
        } else {

        }
        
      }, [savedlayouts])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
     // sticky header
     const handleScroll = () => {
      const scrollTop = window.scrollY;
      const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
      setSticky(stickyClass);
      // console.log(stickyClass);
     }

     window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
  }, [])
  return (
    <>
      <div className={classes}>
        <div className="container">
          <div className="headerrow">
            <div className="logodiv">
              <Link to={"/"}>
                <img src={logo} className="mainlogo" />
              </Link>
            </div>
            <div className="header-navbar">
              <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul class="navbar-nav">
                  <li className={"nav-item"}>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className={"nav-item servicehover"}>
                    <Link>Services
                    <span>
                            <FontAwesomeIcon
                              icon={faAngleDown}
                              className=""
                              style={{fontSize: 14, marginLeft: 5}}
                            />
                          </span>
                    </Link>
                    <div className="servicedropdown">
                      <ul>
                        <li className="designhover">
                          Design{" "}
                          <span>
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              className="anglerighticon"
                            />
                          </span>
                          <div className="subdropdown">
                           <ul>
                            <li><Link to={"https://www.theinkorporated.com/inkapi/"}>SlideEZ-AI</Link></li>
                            <li><Link to={"https://www.theinkorporated.com/our-work/"}>Our Work</Link></li>
                           </ul>
                          </div>
                        </li>
                        <li><Link to={"https://www.theinkorporated.com/editing-and-proofreading-services/"}>Editorial</Link></li>
                        <li><Link to={"https://www.theinkorporated.com/content-writing-services/"}>Content</Link></li>
                      </ul>
                    </div>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"https://www.theinkorporated.com/insights/"}>
                      Insights
                    </Link>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"https://www.theinkorporated.com/about-us/"}>
                      About Us
                    </Link>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"https://www.theinkorporated.com/contact-us/"}>
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="header-iconsdiv">
              <div
                className="header-insta-icon"
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/inkorporated-aranca/?originalSubdomain=in",
                    "_blank"
                  );
                }}
              >
                <FontAwesomeIcon
                  icon={faSquareLinkedin}
                  className="headericons"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      <div className="deskhide">
        <div className="mobilemaindiv">
          <div
            className="mobilemenudiv"
            onClick={() => {
              setOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faBars} className="menubaricon" />
          </div>
          <img src={logo} alt="Logo" className="website-logo-m" />
        </div>
        <div className="navbarheight" />
        <Drawer
          anchor="left"
          open={open}
          onClose={() => {
            toggleDrawer(false);
          }}
        >
          <List sx={{ width: 280 }}>
            <div className="mobilemenusidebarmaindiv">
              <div
                className="mobilemenusidebar-closediv"
                onClick={() => {
                  toggleDrawer(false);
                }}
              >
                <FontAwesomeIcon
                  icon={faXmark}
                  className="menubariconsidebar"
                />
              </div>
              <div className="sidebarmain">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li className={"nav-item"}>
                      <Link to={"https://www.theinkorporated.com/"}>Home</Link>
                    </li>
                    <li to={"/"} className={"nav-item"}>
                      <Link>Services</Link>
                    </li>
                    <li className={"nav-item"}>
                      <Link>Insights</Link>
                    </li>
                    <li className={"nav-item"}>
                      <Link>About Us</Link>
                    </li>
                    <li className={"nav-item"}>
                      <Link>Contact Us</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </List>
        </Drawer>
      </div>
      {/* Save Sidebar */}
      {/* <div className="right-arrow-div">
        <div
          className="righticonbox"
          onClick={() => {
            setOpen1(true);
          }}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            className="leftchevicon"
            style={{ color: "#fff", fontSize: 18 }}
          />
        </div>
      </div>
      <Drawer
        anchor="right"
        open={open1}
        onClose={() => {
          toggleDrawer1(false);
        }}
      >
        <List sx={{ width: 280 }}>
          <div className="savesidebar">
            <div
              className="savesidebar-closediv"
              onClick={() => {
                toggleDrawer1(false);
              }}
            >
              <FontAwesomeIcon icon={faXmark} className="sidebariconsidebar" />
            </div>
            {
                savedlayoutsarrRef.current?.length > 0 ?
                <div className="sidebarmain">
              
                <p className="saved-layouttexts">Saved Layouts</p>
                <SortableList listarr={savedlayoutsarrRef.current} handleresp={handlerespfunc} removeLayout={removeLayoutfunc} />
                 <div
                        className="custom-resetbtn sidebar-generate-btn"
                        style={{ backgroundColor: "#198754", minWidth: 116 }}
                        onClick={() => {
                          if (previewloading) {
                          } else {
                            handlegenerateppt();
                          }
                        }}
                      >
                        {previewloading ? (
                          <Spinner
                            color="#fff"
                            size={12}
                            className="previewloader"
                          />
                        ) : (
                          <>
                            <img src={starimg} className="start-img" />
                            <p style={{ color: "#fff" }}>Download</p>
                          </>
                        )}
                      </div>
            </div> :
            <div className="sidebarmain">
              <p className="saved-layouttexts no-layouts-text">No Layouts Added</p>
            </div>
              }
            
          </div>
        </List>
      </Drawer> */}
    </>
  );
}

export default Header